// extracted by mini-css-extract-plugin
export var activeDot = "_5c-c";
export var buttonContainer = "_5c-9";
export var channelButton = "_5c-a";
export var clickable = "_5c-d";
export var content = "_5c-0";
export var contentFull = "_5c-2";
export var contentThird = "_5c-1";
export var contentWrapper = "_5c-7";
export var description = "_5c-5";
export var heightShort = "_5c-f";
export var image = "_5c-3";
export var imageContainer = "_5c-4";
export var selectButton = "_5c-e";
export var spinnerContainer = "_5c-b";
export var titleContent = "_5c-8";
export var titleWrapper = "_5c-6";